import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../translation/TranslationContext';
import OfflineAlert from '../../OfflineAlert/OfflineAlert';

interface OfflineSyncOrderModalContentProps {
  usePluralText?: boolean;
}

const useStyles = makeStyles()((theme) => ({
  subtitle: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },
}));

const OfflineSyncOrderModalContent = ({ usePluralText }: OfflineSyncOrderModalContentProps) => {
  const { classes } = useStyles();

  const { translate } = useTranslation();

  const subtitleLangEnum = usePluralText
    ? LangEnum.OFFLINE_SYNC_MODAL_SUBTITLE_PLURAL
    : LangEnum.OFFLINE_SYNC_MODAL_SUBTITLE;

  const alertLangEnum = usePluralText
    ? LangEnum.OFFLINE_SYNC_MODAL_ALERT_PLURAL
    : LangEnum.OFFLINE_SYNC_MODAL_ALERT;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
      }}
    >
      <Typography color="textSecondary" className={classes.subtitle}>
        {translate(subtitleLangEnum)}
      </Typography>
      <OfflineAlert>
        <Typography variant="body2" style={{ fontWeight: 500 }} color="textPrimary">
          {translate(alertLangEnum)}
        </Typography>
      </OfflineAlert>
    </Box>
  );
};

export default OfflineSyncOrderModalContent;
